import { IPostDocumentUploadQuery } from "../../../interfaces/api/IDocuments";

export default class PostDocumentUploadQuery implements IPostDocumentUploadQuery {
    file: File;
    type: string;
    description: string;
    client_types: string[] = [];
    date_validity_start?: string;
    date_validity_end?: string;

    constructor(postDocumentUploadQuery: IPostDocumentUploadQuery) {
        this.file = postDocumentUploadQuery.file;
        this.type = postDocumentUploadQuery.type;
        this.description = postDocumentUploadQuery.description;
        this.client_types = postDocumentUploadQuery.client_types;
        this.date_validity_start = postDocumentUploadQuery.date_validity_start;
        this.date_validity_end = postDocumentUploadQuery.date_validity_end;
    }
}